import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerService } from '../../customer/customer.service';
import { DataService } from '../../data/data.service';

@Component({
    selector: 'app-header',
    template: `
    <div class="w-100 h-50px d-flex justify-content-between flex-row bg-white border-bottom shadow-sm fixed-top">
      <div class="d-flex align-items-center">
        <ng-content select="[start]"></ng-content>
        <app-sound-control></app-sound-control>
      </div>

      <div class="d-flex align-items-center">
      <span
          *ngIf="!dataService.cashBoxClosed && !isPaymentRoute"
          class="d-inline-block bg-light rounded-pill py-1 px-3 ms-1 fs-5 min-w-160px text-center">
          {{dataService.cashBox.cashBalance | currency}}
        </span>

        <span
          *ngIf="dataService.cashBoxClosed"
          class="d-inline-block bg-light rounded-pill py-1 px-3 ms-1 fs-5 min-w-160px">&nbsp;</span>
      </div>

      <div class="bg-white  me-1">
        <button class="btn text-muted btn-focus-no-shadow py-1" [routerLink]="['/cart']">
          <span class="position-relative d-block">
            <span *ngIf="dataService.orderedItemsCount > 0 && !dataService.cashBoxClosed" [@badgeChange]="dataService.orderedItemsCount"
                  class="position-absolute top-0 start-100 badge item-count-badge rounded-pill bg-info">
              {{dataService.orderedItemsCount}}
            </span>
          <span class="material-icons">shopping_cart</span>
          </span>
        </button>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
    }

    .item-count-badge {
      transform: translate(-40%, -15%);
    }
  `],
    animations: [
        trigger('badgeChange', [
            transition(':enter, :increment, :decrement', [
                animate('0.5s ease-in-out', keyframes([
                    style({
                        padding: '0.35em 0.65em',
                        fontSize: '0.75em',
                        transform: 'translate(-40%, -15%)'
                    }),
                    style({
                        padding: '1em 1em',
                        fontSize: '1em',
                        transform: 'translate(-70%, 15%)'
                    }),
                    style({
                        padding: '0.35em 0.65em',
                        fontSize: '0.75em',
                        transform: 'translate(-40%, -15%)'
                    })
                ]))
            ])
        ]),
    ],
    standalone: false
})
export class HeaderComponent {
  isPaymentRoute: boolean = false;

  constructor(
    public dataService: DataService, 
    private readonly customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.router.events.subscribe(() => {
      this.isPaymentRoute = this.router.url.includes('/payment');
    });
  }

  async openNewCustomerModal() {
    const newCustomerData = await this.customerService.openNewCustomerModal();
    if (!newCustomerData) {
      return;
    }
    this.dataService.createNewCustomer(newCustomerData);
  }
}
